import { authFetch } from '../utils/authFetch';
import { baseUrl } from '../utils/requestUrl';

export const getClinicalSites = async () => {
    
    const organizationId = JSON.parse(localStorage.getItem('user')).organizations?.find((org)=>org.active === true)?.id;
    const response = await authFetch(`${baseUrl}/clinicalSites/byOrganization/${organizationId}`);
    return response.json();
}

export const getClinicalSiteById = async (id) => {
    const response = await authFetch(`${baseUrl}/clinicalsites/${id}`);
    return response.json();
}

export const getClinicalSiteRoles = async () => {
    const response = await authFetch(`${baseUrl}/clinicalSites/roles`);
    return response.json();
};

export const getPatientsByClinicalSite = async (clinicalSiteId) => {
    const response = await authFetch(`${baseUrl}/clinicalsites/${clinicalSiteId}/patients?pageNumber=1&pageSize=100`);
    return response.json();
};

export const createClinicalSite = async (clinicalSiteData) => {
    try {
        const response = await authFetch(`${baseUrl}/clinicalsites`, {
            method: 'POST',
            body: JSON.stringify(clinicalSiteData),
        });
        return response.json();
    } catch (error) {
        throw error;
    }
};

export const getClinicalSiteStats = async (clinicalSiteId) => {
    const response = await authFetch(`${baseUrl}/clinicalsites/${clinicalSiteId}/stats`);
    return response.json();
};
// export const getClinicalSites = () => {
//     return [
//         {
//             id: 1,
//             clinicalSiteName: 'TOH - General Campus',
//             clinicalSiteType: '',
//             city: 'Ottawa ON', 
//             province: 'Ontario', 
//             country: 'Canada', 
//             postalCode: '',
//             streetAddress: '501 Smythe Rd. ', 
//             suite: 'K1H 8L6',
//             phoneNumber: '',
//             hcp: 56,
//             createdAt: '2 July 1964',
//             patients: 23
//         },
//         {
//             id: 2,
//             clinicalSiteName: 'TOH - Riverside Campus',
//             clinicalSiteType: '',
//             city: 'Ottawa ON', 
//             province: 'Ontario', 
//             country: 'Canada', 
//             postalCode: '',
//             streetAddress: '1967 Riverside Dr.', 
//             suite: 'K1H 7W9',
//             phoneNumber: '',
//             hcp: 56,
//             createdAt: '2 July 1964',
//             patients: 23
//         },
//         {
//             id: 3,
//             clinicalSiteName: 'Somerset West Community Health Centre',
//             clinicalSiteType: '',
//             city: 'ON', 
//             province: 'Ontario', 
//             country: 'Canada', 
//             postalCode: '',
//             streetAddress: '55 Eccles St. Ottawa ', 
//             suite: 'K1R 6S3',
//             phoneNumber: '',
//             hcp: 56,
//             createdAt: '2 July 1964',
//             patients: 23
//         },
//         {
//             id: 4,
//             clinicalSiteName: 'TOH - Civic Campus',
//             clinicalSiteType: '',
//             city: 'Ottawa ON', 
//             province: 'Ontario', 
//             country: 'Canada', 
//             postalCode: '',
//             streetAddress: '1053 Carling Ave. ', 
//             suite: 'K1Y 4E9',
//             phoneNumber: '',
//             hcp: 56,
//             createdAt: '2 July 1964',
//             patients: 23
//         },
//         {
//             id: 5,
//             clinicalSiteName: 'Trinity Family Medicine',
//             clinicalSiteType: '',
//             city: 'Ottawa ON', 
//             province: 'Ontario', 
//             country: 'Canada', 
//             postalCode: '',
//             streetAddress: '876 Montreal Rd. ', 
//             suite: 'K1K 4L3',
//             phoneNumber: '',
//             hcp: 56,
//             createdAt: '2 July 1964',
//             patients: 23
//         },

//     ]
// }